import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddIroSectionLink',
  setup: function setup(__props) {
    var name = ref('');
    var loading = false;
    return {
      __sfc: true,
      name: name,
      loading: loading
    };
  }
});